import React from "react";
import { CalendarCheck, ArrowRight } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { trackEvent } from "@/lib/analytics";

export default function CalendlyButton({ label = "Book Consultation", source = "page", className = "btn-gold", testId = "calendly-cta" }) {
  const settings = useSettings();

  const onClick = () => {
    trackEvent("calendly_click", { source });
    window.open(settings.calendly_url, "_blank");
  };

  return (
    <button onClick={onClick} className={className} data-testid={testId}>
      <CalendarCheck className="w-4 h-4" /> {label} <ArrowRight className="w-3.5 h-3.5" />
    </button>
  );
}
